module.exports = __webpack_public_path__ + "static/media/gr_reprocess_template.f5c70897.xlsx";